function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = [
    "defaultSlots",
    "defaultSlotProps",
    "slots",
    "slotProps"
];
import * as React from 'react';
import PropTypes from 'prop-types';
import { forwardRef } from '@mui/x-internals/forwardRef';
import { useGridColumnMenuSlots } from "../../../hooks/features/columnMenu/useGridColumnMenuSlots.js";
import { GridColumnMenuContainer } from "./GridColumnMenuContainer.js";
import { GridColumnMenuColumnsItem } from "./menuItems/GridColumnMenuColumnsItem.js";
import { GridColumnMenuFilterItem } from "./menuItems/GridColumnMenuFilterItem.js";
import { GridColumnMenuSortItem } from "./menuItems/GridColumnMenuSortItem.js";
import { jsx as _jsx } from "react/jsx-runtime";
export var GRID_COLUMN_MENU_SLOTS = {
    columnMenuSortItem: GridColumnMenuSortItem,
    columnMenuFilterItem: GridColumnMenuFilterItem,
    columnMenuColumnsItem: GridColumnMenuColumnsItem
};
export var GRID_COLUMN_MENU_SLOT_PROPS = {
    columnMenuSortItem: {
        displayOrder: 10
    },
    columnMenuFilterItem: {
        displayOrder: 20
    },
    columnMenuColumnsItem: {
        displayOrder: 30
    }
};
var GridGenericColumnMenu = forwardRef(function GridGenericColumnMenu(props, ref) {
    var defaultSlots = props.defaultSlots, defaultSlotProps = props.defaultSlotProps, slots = props.slots, slotProps = props.slotProps, other = _objectWithoutPropertiesLoose(props, _excluded);
    var orderedSlots = useGridColumnMenuSlots(_extends({}, other, {
        defaultSlots: defaultSlots,
        defaultSlotProps: defaultSlotProps,
        slots: slots,
        slotProps: slotProps
    }));
    return /*#__PURE__*/ _jsx(GridColumnMenuContainer, _extends({}, other, {
        ref: ref,
        children: orderedSlots.map(function(param, index) {
            var _param = _sliced_to_array(param, 2), Component = _param[0], otherProps = _param[1];
            return /*#__PURE__*/ _jsx(Component, _extends({}, otherProps), index);
        })
    }));
});
process.env.NODE_ENV !== "production" ? GridGenericColumnMenu.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // | To update them edit the TypeScript types and run "pnpm proptypes"  |
    // ----------------------------------------------------------------------
    colDef: PropTypes.object.isRequired,
    /**
   * Initial `slotProps` - it is internal, to be overrriden by Pro or Premium packages
   * @ignore - do not document.
   */ defaultSlotProps: PropTypes.object.isRequired,
    /**
   * Initial `slots` - it is internal, to be overrriden by Pro or Premium packages
   * @ignore - do not document.
   */ defaultSlots: PropTypes.object.isRequired,
    hideMenu: PropTypes.func.isRequired,
    id: PropTypes.string,
    labelledby: PropTypes.string,
    open: PropTypes.bool.isRequired,
    /**
   * Could be used to pass new props or override props specific to a column menu component
   * e.g. `displayOrder`
   */ slotProps: PropTypes.object,
    /**
   * `slots` could be used to add new and (or) override default column menu items
   * If you register a nee component you must pass it's `displayOrder` in `slotProps`
   * or it will be placed in the end of the list
   */ slots: PropTypes.object
} : void 0;
var GridColumnMenu = forwardRef(function GridColumnMenu(props, ref) {
    return /*#__PURE__*/ _jsx(GridGenericColumnMenu, _extends({}, props, {
        ref: ref,
        defaultSlots: GRID_COLUMN_MENU_SLOTS,
        defaultSlotProps: GRID_COLUMN_MENU_SLOT_PROPS
    }));
});
process.env.NODE_ENV !== "production" ? GridColumnMenu.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // | To update them edit the TypeScript types and run "pnpm proptypes"  |
    // ----------------------------------------------------------------------
    colDef: PropTypes.object.isRequired,
    hideMenu: PropTypes.func.isRequired,
    id: PropTypes.string,
    labelledby: PropTypes.string,
    open: PropTypes.bool.isRequired,
    /**
   * Could be used to pass new props or override props specific to a column menu component
   * e.g. `displayOrder`
   */ slotProps: PropTypes.object,
    /**
   * `slots` could be used to add new and (or) override default column menu items
   * If you register a nee component you must pass it's `displayOrder` in `slotProps`
   * or it will be placed in the end of the list
   */ slots: PropTypes.object
} : void 0;
export { GridColumnMenu, GridGenericColumnMenu };
